import React, { useEffect, useState } from 'react';
import Layout from '@/components/layout/layout';
import { WebPageSchema, BreadcrumbSchema } from '@/lib/utils/schema-utils';
import Breadcrumb from '@/components/ui/breadcrumb';

export default function TalentRHAIPage() {
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    const loadHubspotForm = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "4621272",
          formId: "1104be1a-7b6a-40dc-b49e-fee2ff0446d8",
          target: "#hubspot-form",
          onFormSubmitted: () => setFormSubmitted(true),
        });
      }
    };

    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/v2.js';
    script.async = true;
    script.onload = loadHubspotForm;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <WebPageSchema 
        page={{
          title: "Talent RH AI | Recruteurs.io",
          description: "Un assistant IA formé pour aider les recruteurs à structurer leurs actions RH : recrutement, marque employeur, formation, process…",
          url: "https://recruteurs.io/entreprise/talent-rhai",
          lastReviewed: "2025-06-01"
        }}
      />

      <BreadcrumbSchema
        items={[
          { name: "Accueil", url: "https://recruteurs.io" },
          { name: "Entreprise", url: "https://recruteurs.io/entreprise" },
          { name: "Talent RH AI", url: "https://recruteurs.io/entreprise/talent-rhai" }
        ]}
      />

      <Layout
        title="Assistant IA pour les RH"
        description="Un bot intelligent pour accompagner les recruteurs sur tous les sujets stratégiques."
      >
        <section className="py-28 px-6 text-center bg-gradient-to-br from-yellow-100 via-pink-100 to-blue-100">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 flex justify-center items-center gap-3">
              <span className="text-4xl sm:text-5xl leading-none" style={{ color: 'initial' }}>
                🎯
              </span>
              <span className="bg-gradient-to-r from-pink-500 to-red-500 text-transparent bg-clip-text">
                Talent RH AI : l’assistant IA des recruteurs
              </span>
            </h1>
            <Breadcrumb 
              items={[
                { name: "Entreprise", href: "/entreprise" },
                { name: "Talent RH AI", href: "/entreprise/talent-rhai" }
              ]} 
            />
            <p className="text-lg md:text-xl max-w-2xl mx-auto mt-6">
              Plan RH, stratégie de recrutement, marque employeur, onboarding… notre IA répond à toutes vos questions, sur mesure.
            </p>
          </div>
        </section>

        {!formSubmitted && (
          <section className="py-20 px-6 bg-white text-center">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl font-bold mb-4">
                🔐 Débloquez l’accès à votre assistant IA
              </h2>
              <p className="mb-6 text-neutral-700">
                Remplissez le formulaire ci-dessous pour accéder gratuitement à Talent RH AI.
              </p>
              <div id="hubspot-form" className="w-full" />
            </div>
          </section>
        )}

        {formSubmitted && (
          <section className="py-20 px-6 bg-white min-h-[80vh] flex items-center justify-center">
            <div className="w-full max-w-4xl">
              <iframe
                id="chatbase-full"
                src="https://www.chatbase.co/chatbot-iframe/B-yCETKMIBROl19MyTnEz"
                title="Talent RH AI Chatbot"
                width="100%"
                height="600"
                className="rounded-xl shadow-xl border border-neutral-200"
              />
            </div>
          </section>
        )}

        <section className="bg-white px-6 md:px-16 py-20 border-t border-neutral-100 text-neutral-700">
          <div className="max-w-4xl mx-auto text-lg leading-relaxed">
            <h2 className="text-2xl font-bold mb-4 text-gradient">🤖 À propos de Talent RH AI</h2>
            <p className="mb-4">
              Talent RH AI est un assistant intelligent conçu pour répondre aux enjeux des responsables RH, recruteurs et dirigeants. Grâce à l'IA, il vous guide dans la structuration de votre stratégie de recrutement, la définition de votre marque employeur ou l'élaboration d'un plan de formation.
            </p>
            <p className="mb-4">
              Développé par Recruteurs.io, il s'appuie sur une base de données actualisée et contextualisée (marché, métiers, régions) pour vous donner des réponses concrètes et activables.
            </p>
            <p className="mb-4">
              Recruteurs.io est un cabinet de recrutement basé à Marseille, avec un positionnement unique en France : allier IA, sourcing humain et garantie de résultat.
            </p>
            <p>
              Rejoignez les professionnels qui utilisent déjà Talent RH AI pour accélérer leurs décisions RH et gagner en efficacité !
            </p>
          </div>
        </section>
      </Layout>
    </>
  );
}